// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2J0yE","range":"MonthRangeSwitch_range__1-I0k","disabled":"MonthRangeSwitch_disabled__1ca4i"};